import { TableTitles } from "@/constants"
import { useGetMeditationRetreats } from "@/hooks/query-hooks/useMeditationRetreats"
import { Button, Divider, Space } from "antd"
import { useState } from "react"
import { Helmet } from 'react-helmet-async'
import { AiOutlineEye } from "react-icons/ai"
import { Link } from "react-router"
import { AnimatedComponent, PageTitle } from "../common"
import { MeditationRetreatsTable } from "./MeditationRetreatsTable"

export function MeditationRetreatList() {

    const [page, setPage] = useState(1)
    const { data, isLoading } = useGetMeditationRetreats(page);

    const meditationRetreats = data?.content || [];

    const renderColumnsKey = [
        TableTitles.retreat_start_month,
        TableTitles.retreat_level,
        TableTitles.retreat_name,
        TableTitles.retreat_duration,
        TableTitles.retreat_end_date,
        TableTitles.retreat_start_date,
        TableTitles.total_registrants,
        TableTitles.retreat_status,
        TableTitles.action
    ]

    return (
        <AnimatedComponent
            className="space-y-6"
        >
            <Helmet>
                <title>တရားစခန်းအလိုက်ယောဂီစာရင်း</title>
            </Helmet>
            <PageTitle>
                တရားစခန်းအလိုက်ယောဂီစာရင်း
            </PageTitle>
            <Divider />
            <MeditationRetreatsTable
                dataSource={meditationRetreats}
                renderColumnKeys={renderColumnsKey}
                rowKey={r => r.id}
                TableActionComponent={TableActionComponent}
                loading={isLoading}
                pagination={{
                    current: page,
                    total: data?.totalElements || 0,
                    onChange: (page) => setPage(page),
                }}
            />
        </AnimatedComponent>
    )
}

const TableActionComponent = ({ record }: { record: MeditationRetreat }) => {

    return (
        <Space>
            <Link
                to={`/meditator-list-by-retreat/${record.id}`}
                className="flex items-center justify-center"
            >
                <Button
                    type="link"
                >
                    <AiOutlineEye
                        size={16}
                    />
                </Button>
            </Link>
        </Space>
    )
}
